import moment from "moment";

export const formatPlanillaDate = (value) => {
  if (!value) return "No disponible";

  const parsed = moment(value);

  return parsed.isValid() ? parsed.format("DD/MM/YYYY") : "No disponible";
};

export const planillaDueDate = (endAt, issuedAt) => {
  if (!endAt) return null;

  const end = moment(endAt);
  const issued = issuedAt ? moment(issuedAt) : null;

  if (!end.isValid()) return null;

  return issued && issued.isValid() && issued.isAfter(end, "day") ? issued : end;
};
